import { TranslationFunction as TF } from 'i18next';
import { Theme, TranslationKey, TranslationsMap, PrivacyPolicyType, Audience, ComponentSettings } from '../../types';
import { SettingsState } from '../store';
import { TranslationFunction } from 'react-i18next';

const getDefaultTranslations = (t: TF): TranslationsMap => ({
  [TranslationKey.ConsentButton]: t(`site:${TranslationKey.ConsentButton}`),
  [TranslationKey.SettingButton]: t(`site:${TranslationKey.SettingButton}`),
  [TranslationKey.PrivacyLink]: t(`site:${TranslationKey.PrivacyLink}`),
  [TranslationKey.PrivacyInfo]: t(`site:${TranslationKey.PrivacyInfo}`),
  [TranslationKey.PolicyUrl]: t(`site:${TranslationKey.PolicyUrl}`),
  [TranslationKey.SaveButton]: t(`site:${TranslationKey.SaveButton}`),
  [TranslationKey.EssensialCategoryHeadline]: t(`site:${TranslationKey.EssensialCategoryHeadline}`),
  [TranslationKey.EssensialCategoryParagraph]: t(`site:${TranslationKey.EssensialCategoryParagraph}`),
  [TranslationKey.MarketingCategoryHeadline]: t(`site:${TranslationKey.MarketingCategoryHeadline}`),
  [TranslationKey.MarketingCategoryParagraph]: t(`site:${TranslationKey.MarketingCategoryParagraph}`),
  [TranslationKey.FunctionalCategoryHeadline]: t(`site:${TranslationKey.FunctionalCategoryHeadline}`),
  [TranslationKey.FunctionalCategoryParagraph]: t(`site:${TranslationKey.FunctionalCategoryParagraph}`),
  [TranslationKey.AnalyticsCategoryHeadline]: t(`site:${TranslationKey.AnalyticsCategoryHeadline}`),
  [TranslationKey.AnalyticsCategoryParagraph]: t(`site:${TranslationKey.AnalyticsCategoryParagraph}`),
});

export const getDefaultTranslationValues = (t: TF, translations: Partial<TranslationsMap> = {}): TranslationsMap => ({
  ...getDefaultTranslations(t),
  ...translations,
});

export type InitialStateOptions = {
  t: TranslationFunction;
  componentSettings: ComponentSettings;
};

export const getInitialState = ({ t, componentSettings: { settings } }: InitialStateOptions): SettingsState => ({
  appSettings: {
    cookiePolicyRequirementApproved: false,
    texts: getDefaultTranslationValues(t, settings.texts),
    appEnabled: false,
    theme: Theme.light,
    privacyPolicyType: PrivacyPolicyType.PageOnSite,
    privacyPolicyPage: '',
    audience: Audience.AllVisitors,
    ...settings,
  },
});
